import React, { useState } from 'react'
import './tabswitch.css'
import dot from "../../assets/dots.svg"
import tabSwitchImageOne from '../../assets/Group 5.svg'
import tabSwitchImageTwo from "../../assets/Group 6.svg"
import tabSwitchImageThree from "../../assets/Group 7.svg"
import tabSwitchImageFour from "../../assets/Group 8.svg"
import checkMark from "../../assets/checkmark.svg"

const TabSwitchSection = () => {
    const [activeTab, setActiveTab] = useState(0)

    const tabData = [
        {
            id: 0,
            title: "Root Cause Intelligence",
            desc: "Uses LLMs and telemetry context to pinpoint causes across services",
            heading: "Root Cause Intelligence",
            content: [
                { title: "Automated RCA", text: "Leverages LLMs to analyze telemetry and surface the most likely root cause." },
                { title: "Cross-Service Correlation", text: "Connects signals across logs, metrics, and traces to eliminate guesswork." }
            ],
            image: tabSwitchImageFour
        },
        {
            id: 1,
            title: "Autonomous Remediation",
            desc: "Executes predefined or learned remediation flows using scripts/APIs",
            heading: "Autonomous Remediation",
            content: [
                { title: "Predefined Playbooks", text: "Run standardized remediation scripts instantly to resolve common issues." },
                { title: "Self-Learning Automation", text: "Continuously adapts flows using AI to handle new and complex incidents." }
            ],
            image: tabSwitchImageOne
        },
        {
            id: 2,
            title: "FinOps Alignment",
            desc: "Ensures tagging, budget tracking, and optimization via AI agents",
            heading: "FinOps Alignment",
            content: [
                { title: "Automated Tagging", text: "Ensure consistent resource tagging for accurate cost allocation." },
                { title: "Budget Tracking & Optimization", text: "AI-driven insights to prevent overruns and maximize savings." }
            ],
            image: tabSwitchImageThree
        },
        {
            id: 3,
            title: "Observability Ingestion",
            desc: "Ingests logs, metrics, traces from OpenTelemetry, Prometheus, Datadog",
            heading: "Observability Ingestion",
            content: [
                { title: "Logs", text: "Seamlessly ingest structured and unstructured logs for complete visibility." },
                { title: "Metrics", text: "Collect performance and infrastructure metrics at scale with zero overhead." },
            ],
            image: tabSwitchImageTwo
        }
    ]

    return (
        <section className="solution-section" id="solutions">
            <div className="container">
                <div className="section-wrapper">
                    <div className="section-heading">
                        <div className="section-tag">
                            <img src={dot} alt='dot-image' />
                            <p>Key Features</p>
                        </div>
                        <div className="heading-description">
                            <h2>Observability 3.0 - Key Features and Capabilities</h2>
                            <p>
                               What Powers AgentSRE
                            </p>
                        </div>
                    </div>
                </div>
                <div className="tabs-switch-wrapper">
                    <div className="tabs">
                        {tabData.map((tab, index) => (
                            <div
                                key={tab.id}
                                className={`tab-switch-link ${activeTab === index ? "active" : ""}`}
                                onClick={() => setActiveTab(index)}
                            >
                                <span>{`0${index + 1}`}</span>
                                <h3>{tab.title}</h3>
                                <p>{tab.desc}</p>
                            </div>
                        ))}
                    </div>
                    <div className="tab-switch-body-wrapper">
                        {tabData.map((tab, index) => (
                            <div
                                key={tab.id}
                                className={`first-tab-switch-body ${activeTab === index ? "active" : ""}`}
                            >
                                <div className="tab-switch-content-body">
                                    <div className="tab-switch-text">
                                        <h4>
                                            <span>{`0${index + 1}`}</span>
                                            <br />
                                            {tab.heading}
                                        </h4>
                                        <p>{tab.desc}</p>
                                        <ul>
                                            {tab.content.map((item, i) => (
                                                <li key={i}>
                                                    <img src={checkMark} alt="checkmark" className='check-mark-icon' />
                                                    <p>
                                                        <span className="checklist-heading">{item.title}:</span> {item.text}
                                                    </p>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="tab-switch-image">
                                        <img src={tab.image} alt={`tab-${index}-image`} />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default TabSwitchSection
